module.exports = __webpack_public_path__ + "img/familytime.b37ae956.jpg";